<template>
  <div
    v-if="!isEmpty"
    class="typography-body-2-regular h-full py-md"
  >
    <OrChart
      ref="Chart"
      :apex-options="apexOptions"
      animated
      :data="dataForChart"
    />
  </div>
  <div
    v-else
    class="flex flex-col items-center content-center justify-around h-full text-on-background dark:text-on-background-dark w-full min-h-[300px]"
  >
    {{ $t('monitoringModal.noData') }}
  </div>
</template>
<script lang="ts">

import { defineComponent, PropType } from 'vue';
import { MetricData } from '../../types';
import { OrChart } from '@onereach/charts';
import _ from 'lodash';

export default defineComponent({
  name: 'MonitoringTable',
  components: {
    OrChart,
  },
  props: {
    metricData: {
      type: Array as PropType<MetricData[]>,
      required: true,
    },
  },
  data() {
    return {
      apexOptions: {
        chart: {
          height: 300,
        },
      },
    };
  },
  computed: {
    arrayMonitoring() {
      return this.metricData;
    },

    dataForChart() {
      return {
        chartType: 'curvy area',
        rows: this.arrayMonitoring,
      };
    },
    isEmpty(): boolean {
      return _.isEmpty(this.arrayMonitoring);
    },
  },
});
</script>
